import { PropsWithChildren } from "react";
import { uiThemeTokens } from "../theme/tokens";
import { App as AntdApp, ConfigProvider } from "antd";
import "antd/dist/reset.css";

export const UIProvider = ({ children }: PropsWithChildren) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: uiThemeTokens.colorPrimary,
          colorSuccess: uiThemeTokens.colorSuccess,
          colorWarning: uiThemeTokens.colorWarning,
          colorError: uiThemeTokens.colorError,
          colorBgBase: uiThemeTokens.colorBgBase,
          colorTextBase: uiThemeTokens.colorTextBase,
          borderRadius: uiThemeTokens.borderRadius,
          borderRadiusLG: uiThemeTokens.borderRadiusLG,
          controlHeight: uiThemeTokens.controlHeight,
          controlHeightLG: uiThemeTokens.controlHeightLG,
          fontFamily: uiThemeTokens.fontFamily,
        },
      }}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
};
